<template>
  <router-view>
    <lennoc-spinner v-show="busy" isFullscreen="false" />
  </router-view>
</template>

<script>
import { mapGetters } from 'vuex'
import { cultureCheck } from '@/utils/cultureCheck'

export default {
  name: 'app',
  computed: {
    ...mapGetters({
      getCulture: 'getCulture',
      isBusy: 'dossier/getIsBusy'
    }),
    busy () {
      return this.isBusy
    }
  },
  beforeMount () {
    this.$store.dispatch('uistrings/fetchUiStrings', cultureCheck().includes('nl')
      ? 'NL'
      : cultureCheck().includes('de')
        ? 'DE'
        : 'GB'
    )
  }
}
</script>

<style lang="less">
// imports for deployable project
@import "less/project";
</style>
